import {Injectable} from '@angular/core';
import {Actions} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {NotificationService} from '@orga-app/providers/notification.service';
import {PageState} from './mandantenverwaltung-technik.reducer';

@Injectable()
export class MandantenverwaltungTechnikEffectsWs {


    constructor(private actions$: Actions,
                private store: Store<PageState>,
                private notificationService: NotificationService) {
    }
}
